import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const PauseIcon = createIcon({
  displayName: 'PauseIcon',
  path: [
    <path
      d='M8 19c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2v10c0 1.1.9 2 2 2Zm6-12v10c0 1.1.9 2 2 2s2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2Z'
      fill={'currentColor'}
    />
  ],
  defaultProps: defaultProps
})
